document.addEventListener('DOMContentLoaded', function (event) {
    const blockFeedback = document.querySelector('.block-feedback');

    if (blockFeedback) { 
        const submitBtn = blockFeedback.querySelector('.wpcf7-submit');
        submitBtn.disabled = false;
    }
});